import React from "react";
import * as Icons from "lucide-react";
import { cn } from "@/lib/utils";
import { Reveal } from "@/components/common/Reveal";

/**
 * Generic feature card: icon + title + description (+ optional bullet list).
 */
export const FeatureCard = ({ icon = "Sparkles", title, description, bullets, delay = 0, className = "" }) => {
  const Icon = Icons[icon] || Icons.Sparkles;
  return (
    <Reveal delay={delay} className="h-full">
      <div className={cn("et-card et-card-hover h-full p-6", className)}>
        <span className="et-icon-box"><Icon className="h-5 w-5" /></span>
        <h3 className="font-display text-lg font-semibold text-slate-900 mt-4">{title}</h3>
        {description && <p className="mt-2 text-sm text-slate-600 leading-relaxed">{description}</p>}
        {bullets && (
          <ul className="mt-4 space-y-2">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-2 text-sm text-slate-600">
                <Icons.Check className="h-4 w-4 text-[var(--et-primary)] mt-0.5 shrink-0" /> {b}
              </li>
            ))}
          </ul>
        )}
      </div>
    </Reveal>
  );
};
